import { render, staticRenderFns } from "./PublicProfileCard.vue?vue&type=template&id=192d3ad7"
import script from "./PublicProfileCard.vue?vue&type=script&lang=js"
export * from "./PublicProfileCard.vue?vue&type=script&lang=js"
import style0 from "./PublicProfileCard.vue?vue&type=style&index=0&id=192d3ad7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports